module.exports = __webpack_public_path__ + "img/bibliophile-screenshot.2c02f66c.jpg";